import { qrScanApi } from '../services/api';
import { isUrl } from './urlUtils';

/**
 * 通过后端 Python pyzbar 扫描照片中的二维码
 * @param {number} photoId - 照片 ID
 * @returns {Promise<string|null>} - 解码出的内容，未识别返回 null
 */
export const scanQrCode = async (photoId) => {
  try {
    const res = await qrScanApi.scan(photoId);
    return res.data?.content || null;
  } catch {
    return null;
  }
};

export { isUrl };

